/* ============================================================
   moltua — JS del tema
   Carrito AJAX · drawer · FAQ · galería PDP · variantes · sticky ATC
   ============================================================ */
(function(){
  'use strict';

  const money = (cents) => {
    const fmt = (window.moltuaMoneyFormat || '${{amount}}');
    const amount = (cents/100).toLocaleString('es-MX',{minimumFractionDigits:2,maximumFractionDigits:2});
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount);
  };

  /* ---------- HEADER scroll ---------- */
  const header = document.querySelector('.site-header');
  if(header){
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
  }

  /* ---------- MENÚ MÓVIL ---------- */
  const burger = document.querySelector('.header-burger');
  const mobileNav = document.querySelector('.mobile-nav');
  const navOverlay = document.querySelector('.nav-overlay');
  const openNav = () => { mobileNav?.classList.add('open'); navOverlay?.classList.add('open'); document.body.style.overflow='hidden'; };
  const closeNav = () => { mobileNav?.classList.remove('open'); navOverlay?.classList.remove('open'); document.body.style.overflow=''; };
  burger?.addEventListener('click', openNav);
  document.querySelector('.mobile-nav-close')?.addEventListener('click', closeNav);
  navOverlay?.addEventListener('click', closeNav);

  /* ---------- FAQ ---------- */
  document.querySelectorAll('.faq-q').forEach(q => {
    q.addEventListener('click', () => {
      const item = q.closest('.faq-item');
      const a = item.querySelector('.faq-a');
      const open = item.classList.contains('open');
      item.classList.toggle('open');
      a.style.maxHeight = open ? null : a.scrollHeight + 'px';
    });
  });

  /* ---------- SCROLL REVEAL ---------- */
  if('IntersectionObserver' in window){
    const io = new IntersectionObserver((entries)=>{
      entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }});
    },{threshold:.12});
    document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
  } else {
    document.querySelectorAll('.reveal').forEach(el=>el.classList.add('in'));
  }

  /* ---------- GALERÍA PDP ---------- */
  const galMain = document.querySelector('.pdp-gallery-main img');
  document.querySelectorAll('.pdp-thumb').forEach(t => {
    t.addEventListener('click', () => {
      const src = t.dataset.full || t.querySelector('img')?.src;
      if(galMain && src){ galMain.src = src; }
      document.querySelectorAll('.pdp-thumb').forEach(x=>x.classList.remove('active'));
      t.classList.add('active');
    });
  });

  /* ---------- VARIANTES PDP ---------- */
  const variantData = window.moltuaVariants || null;
  if(variantData){
    const state = {};
    const selectedSpan = {};
    document.querySelectorAll('.variant-swatch[data-option]').forEach(sw => {
      const idx = sw.dataset.option;
      if(sw.classList.contains('active')) state[idx] = sw.dataset.value;
      sw.addEventListener('click', () => {
        document.querySelectorAll(`.variant-swatch[data-option="${idx}"]`).forEach(x=>x.classList.remove('active'));
        sw.classList.add('active');
        state[idx] = sw.dataset.value;
        const lbl = document.querySelector(`.variant-selected[data-option="${idx}"]`);
        if(lbl) lbl.textContent = sw.dataset.value;
        resolveVariant();
      });
    });
    function resolveVariant(){
      const chosen = Object.keys(state).sort().map(k=>state[k]);
      const match = variantData.find(v => JSON.stringify(v.options) === JSON.stringify(chosen));
      const idInput = document.querySelector('input[name="id"]');
      const priceEl = document.querySelector('.pdp-price');
      const compareEl = document.querySelector('.pdp-price-compare');
      const stickyPrice = document.querySelector('.sticky-atc .s-price');
      const atcBtn = document.querySelector('[data-atc]');
      if(match){
        if(idInput) idInput.value = match.id;
        if(priceEl) priceEl.textContent = money(match.price);
        if(stickyPrice) stickyPrice.firstChild && (stickyPrice.firstChild.textContent = money(match.price));
        if(compareEl){
          if(match.compare_at_price && match.compare_at_price > match.price){
            compareEl.textContent = money(match.compare_at_price); compareEl.style.display='';
          } else { compareEl.style.display='none'; }
        }
        if(atcBtn){
          atcBtn.disabled = !match.available;
          atcBtn.textContent = match.available ? (atcBtn.dataset.label || 'Agregar al carrito') : 'Agotado';
        }
      }
    }
  }

  /* ---------- QTY STEPPER ---------- */
  document.querySelectorAll('.qty-stepper').forEach(st => {
    const input = st.querySelector('input');
    st.querySelector('[data-minus]')?.addEventListener('click',()=>{ input.value = Math.max(1,(parseInt(input.value)||1)-1); });
    st.querySelector('[data-plus]')?.addEventListener('click',()=>{ input.value = (parseInt(input.value)||1)+1; });
  });

  /* ---------- CART DRAWER ---------- */
  const drawer = document.querySelector('.cart-drawer');
  const openCart = () => { drawer?.classList.add('open'); navOverlay?.classList.add('open'); document.body.style.overflow='hidden'; refreshCart(); };
  const closeCart = () => { drawer?.classList.remove('open'); navOverlay?.classList.remove('open'); document.body.style.overflow=''; };
  document.querySelectorAll('[data-open-cart]').forEach(b=>b.addEventListener('click',(e)=>{e.preventDefault();openCart();}));
  document.querySelector('.cart-close')?.addEventListener('click', closeCart);

  function renderCart(cart){
    const itemsEl = document.querySelector('.cart-items');
    const subtotalEl = document.querySelector('.cart-foot .subtotal span:last-child');
    const countEls = document.querySelectorAll('.cart-count');
    if(countEls) countEls.forEach(c=>{ c.textContent = cart.item_count; c.style.display = cart.item_count>0?'flex':'none'; });
    if(!itemsEl) return;
    if(cart.item_count === 0){
      itemsEl.innerHTML = '<div class="cart-empty">Tu carrito está vacío.<br>El vórtice te espera.</div>';
      if(subtotalEl) subtotalEl.textContent = money(0);
      const footBtn = document.querySelector('.cart-foot .btn'); if(footBtn) footBtn.style.display='none';
      return;
    }
    const footBtn = document.querySelector('.cart-foot .btn'); if(footBtn) footBtn.style.display='';
    itemsEl.innerHTML = cart.items.map(it => `
      <div class="cart-line" data-key="${it.key}">
        <img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i,'_120x$1$2') : ''}" alt="${it.product_title}">
        <div style="flex:1">
          <div class="cl-title">${it.product_title}</div>
          ${it.variant_title && it.variant_title!=='Default Title' ? `<div class="cl-variant">${it.variant_title}</div>`:''}
          <div style="display:flex;justify-content:space-between;align-items:center;margin-top:8px">
            <div class="qty-stepper" style="transform:scale(.82);transform-origin:left">
              <button data-cart-minus>−</button>
              <input value="${it.quantity}" readonly>
              <button data-cart-plus>+</button>
            </div>
            <span style="font-family:var(--font-exp);font-weight:700">${money(it.final_line_price)}</span>
          </div>
        </div>
        <button data-cart-remove style="background:none;border:none;color:var(--niebla);font-size:.8rem;align-self:flex-start">✕</button>
      </div>`).join('');
    if(subtotalEl) subtotalEl.textContent = money(cart.total_price);
    bindCartLines();
  }

  function bindCartLines(){
    document.querySelectorAll('.cart-line').forEach(line => {
      const key = line.dataset.key;
      const qty = parseInt(line.querySelector('input').value)||1;
      line.querySelector('[data-cart-minus]')?.addEventListener('click',()=>changeItem(key, qty-1));
      line.querySelector('[data-cart-plus]')?.addEventListener('click',()=>changeItem(key, qty+1));
      line.querySelector('[data-cart-remove]')?.addEventListener('click',()=>changeItem(key, 0));
    });
  }

  function changeItem(key, quantity){
    fetch('/cart/change.js',{
      method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key, quantity:Math.max(0,quantity)})
    }).then(r=>r.json()).then(renderCart);
  }

  function refreshCart(){
    fetch('/cart.js').then(r=>r.json()).then(renderCart).catch(()=>{});
  }

  /* ---------- ADD TO CART (AJAX) ---------- */
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const original = btn ? btn.textContent : '';
      if(btn){ btn.disabled = true; btn.textContent = 'Agregando…'; }
      fetch('/cart/add.js',{
        method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify(Object.fromEntries(new FormData(form)))
      }).then(r=>r.json()).then(()=>{
        if(btn){ btn.textContent = '¡Listo! ✓'; setTimeout(()=>{btn.textContent=original;btn.disabled=false;},1400); }
        openCart();
      }).catch(()=>{ if(btn){ btn.textContent=original; btn.disabled=false; } });
    });
  });

  refreshCart();

  /* ---------- STICKY ATC (móvil) ---------- */
  const sticky = document.querySelector('.sticky-atc');
  const buybox = document.querySelector('.pdp-buybox');
  if(sticky && buybox && 'IntersectionObserver' in window){
    const io = new IntersectionObserver((entries)=>{
      entries.forEach(e => sticky.classList.toggle('show', !e.isIntersecting && window.innerWidth<=820));
    },{threshold:0});
    io.observe(buybox);
    sticky.querySelector('[data-sticky-add]')?.addEventListener('click',()=>{
      document.querySelector('.pdp-atc')?.click();
    });
  }

  /* ---------- SLIDER DE RESEÑAS ---------- */
  const rev = document.querySelector('[data-reviews]');
  if(rev){
    const track = rev.querySelector('[data-reviews-track]');
    const cards = Array.from(track.children);
    const dotsWrap = rev.querySelector('[data-reviews-dots]');
    let idx = 0;
    cards.forEach((_, i)=>{
      const d = document.createElement('button');
      d.setAttribute('aria-label','Reseña '+(i+1));
      if(i===0) d.classList.add('active');
      d.addEventListener('click',()=>goTo(i));
      dotsWrap.appendChild(d);
    });
    const dots = Array.from(dotsWrap.children);
    function goTo(i){
      idx = Math.max(0, Math.min(i, cards.length-1));
      track.scrollTo({left: cards[idx].offsetLeft - track.offsetLeft, behavior:'smooth'});
      dots.forEach((d,j)=>d.classList.toggle('active', j===idx));
    }
    rev.querySelector('[data-rev-prev]')?.addEventListener('click',()=>goTo(idx-1));
    rev.querySelector('[data-rev-next]')?.addEventListener('click',()=>goTo(idx+1));
    let st;
    track.addEventListener('scroll',()=>{
      clearTimeout(st);
      st = setTimeout(()=>{
        let closest=0, min=Infinity;
        cards.forEach((c,i)=>{
          const dist=Math.abs(c.offsetLeft - track.offsetLeft - track.scrollLeft);
          if(dist<min){min=dist;closest=i;}
        });
        idx=closest;
        dots.forEach((d,j)=>d.classList.toggle('active', j===idx));
      },90);
    });
  }

  /* ---------- VIEWERS (pequeña fluctuación natural) ---------- */
  const vc = document.getElementById('viewerCount');
  if(vc){
    const base = parseInt(vc.textContent,10) || 37;
    setInterval(()=>{
      const delta = Math.floor(Math.random()*5)-2;
      let n = base + delta;
      if(n<5) n=5;
      vc.textContent = n;
    }, 4000);
  }
})();
